export default __webpack_public_path__ + "static/media/final.64994d4b.mp4";